import { call, put, takeEvery } from 'redux-saga/effects';
import { 
  deleteChatSessionRequest, 
  deleteChatSessionSuccess, 
  deleteChatSessionFailure 
} from "../slice/deleteChatSessionSlice";
import { deleteChatSessionApi } from '../../api/apiService';
import { getApiError } from "@src/utils/apiError";

// Worker saga
export function* handleDeleteChatSession(action: { payload: { chatSessionId: number|string } }): Generator<any, void, any> {
  try {
    const response = yield call(deleteChatSessionApi, action.payload.chatSessionId);

    if (response && response.data) {
      yield put(deleteChatSessionSuccess(response.data));
    } else {
      yield put(deleteChatSessionFailure('Unexpected response from server'));
    }
  } catch (error: unknown) {
    const apiError = getApiError(error);
    console.error(
        "Delete ChatSession Error:",
        error
    );
    yield put(
        deleteChatSessionFailure(
            apiError.message
        )
    );
  }
}

// Watcher saga
export function* deleteChatSessionSaga() {
  yield takeEvery(deleteChatSessionRequest, handleDeleteChatSession);
}
